import { createContext } from 'react';

export type FeedbackDialogContextProps = {
  openFeedbackDialog: () => void;
};

export const FeedbackDialogContext = createContext<FeedbackDialogContextProps>({
  openFeedbackDialog: () => {},
});
